/** vue-auth の保存APIを通して、更新前のトークンを両方の保存先から除く。 */
const authTokenDriver = {
  request(this: any, req: any, token: string) {
    this.drivers.http.setHeaders.call(this, req, {
      Authorization: 'Bearer ' + token
    })
    if (req.url === this.options.refreshData.url) {
      this.drivers.http.setHeaders.call(this, req, {
        Refresh: this.token(this.options.refreshTokenKey)
      })
    }
  },
  response(this: any, res: any): string | undefined {
    const headers = this.drivers.http.getHeaders.call(this, res)
    const token = headers.Authorization || headers.authorization
    const refreshToken = headers.Refresh || headers.refresh

    if (refreshToken) {
      this.token(this.options.refreshTokenKey, null)
      this.token(this.options.refreshTokenKey, refreshToken)
    }
    if (token) {
      // vue-auth は sessionStorage を優先して読むため、localStorage だけを
      // 更新すると古い値が使われ続ける。保存先を選び直す前に両方を消す。
      this.token(null, null)
      const parts = token.split(/Bearer:?\s?/i)
      return parts[parts.length > 1 ? 1 : 0].trim()
    }
  }
}

export default authTokenDriver
